import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DevFlagsEffects } from './store/dev-flags.effects';
import { DevFlagNamespace, DevFlagReducer, DevFlagConfigToken } from './store/dev-flags.store';

@NgModule({
  imports: [
    StoreModule.forFeature(DevFlagNamespace, DevFlagReducer, DevFlagConfigToken),
    EffectsModule.forFeature([DevFlagsEffects]),
  ],
})
export class DevFlagsDataModule {}
